import { Route, Routes } from 'react-router-dom';
import SpaMainPage from '../pages/spa/SpaMainPage';

export const SpaRouter = () => {
    return (
        <Routes>

            <Route path='/' element={<SpaMainPage />} />

        </Routes>
    );
};
